import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";

export default function useTeams() {
  const { baseurl, token, accessToken, setIsUnauthorised, AdminId } =
    useGlobalContext();

  const [loading, setLoading] = useState(false);

  const createTeam = async (teamName, accuracy, onSuccess) => {
    if (!teamName || !accuracy) {
      toast.error("Please fill all fields");
      return;
    }

    try {
      const payload = {
        teamName,
        device: "web",
        userId: "9",
        accuracy,
        adminId: AdminId,
      };

      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/createDriverTeam`,
        payload,
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (res.data.responseCode === "00") {
        toast.success("Team created successfully");
        onSuccess?.();
      } else {
        toast.error(res.data.responseMessage || "Unable to create team");
      }
    } catch {
      toast.error("Error creating team");
    }
  };

  const updateDutyStatus = async (
    driverCode,
    nextStatus,
    onErrorRollback
  ) => {
    try {
      const payload = {
        device: "Admin",
        userId: "",
        driverId: driverCode,
        dutyValue: nextStatus,
        adminId: AdminId,
      };

      const res = await axios.post(
        `${baseurl}/api/User/v1.0/updateDriverDutyTime`,
        payload,
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (res.data.responseCode === "00") {
        toast.success(`Duty updated: ${nextStatus.replace("_", " ")}`);
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
        onErrorRollback?.();
      } else {
        toast.error(res.data.responseMessage || "Failed to update duty");
        onErrorRollback?.();
      }
    } catch {
      toast.error("Error updating duty status");
      onErrorRollback?.();
    }
  };

  const assignShopToTeam = async (shop, team, onSuccess) => {
    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/assignTeamToShop`,
        {
          shopCode: shop.shop_code,
          teamId: String(team.id),
          adminId: AdminId,
        },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      if (res.data.responseCode === "00") {
        toast.success(`Assigned ${shop.shop_name} to ${team.team_name}`);
        onSuccess?.();
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage || "Failed to assign shop");
      }
    } catch {
      toast.error("Error assigning shop");
    }
  };

  return {
    loading,
    createTeam,
    updateDutyStatus,
    assignShopToTeam,
  };
}
